// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"9f4c0e36","375":"4f7bdb22","829":"b6337dbd"}[chunkId] + ".chunk.js";
};